<template>
    <div>
        <div class="bg-white"style="box-shadow: 0 2px 4px -2px rgba(0,0,0,.2);">
            <div class="container-fluid">
                <b-navbar toggleable="lg" type="light" class="mb-5 mt-2 bg-white">
                    <router-link to="/" class="navbar-brand">
                        <img src="/logo.png" style="height: 25px;" class="mr-2" /> InboxGPT
                    </router-link>

                    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

                    <b-collapse id="nav-collapse" is-nav>

                        <!-- Right aligned nav items -->
                        <b-navbar-nav>

                            <router-link to="/" class="dropdown-item" v-b-tooltip.hover title="Go to your inbox">Inbox</router-link>
                            <router-link to="/compose" class="dropdown-item" v-b-tooltip.hover title="Compose a new message">Compose</router-link>
                            <router-link to="/channels" class="dropdown-item" v-b-tooltip.hover title="Manage your mailboxes">Mailboxes</router-link>
                            <router-link to="/settings" class="dropdown-item" v-b-tooltip.hover title="Manage your team and settings">Team</router-link>
                            <router-link to="/account" class="dropdown-item" v-b-tooltip.hover title="Manage your account">Account</router-link>
                        </b-navbar-nav>

                        <b-navbar-nav class="ml-auto">
                            <b-nav-item-dropdown :text="$auth.user().name" right>
                                <router-link to="/user" class="dropdown-item" v-b-tooltip.hover.left title="Manage your profile">User Settings</router-link>
                                <a class="dropdown-item" @click.prevent="$auth.logout()" v-b-tooltip.hover.left title="Log out">Sign out</a>
                            </b-nav-item-dropdown>
                        </b-navbar-nav>
                    </b-collapse>
                </b-navbar>
            </div>
        </div>
        <div class="container-fluid">

            <vue-page-transition name="fade-in-right">
                <router-view/>
            </vue-page-transition>

            <input type="hidden" :value="$auth.user().email" id="boei_prefill_customer_email" />
            <input type="hidden" :value="$auth.user().name" id="boei_prefill_customer_name" />
        </div>
    </div>
</template>

<script>

    export default{
        data: () => ({
        }),
        async created() {
        },
    }
</script>
